import axios from "../axios";

/**
 * 获取单个传感器信息
 */
export function getDeviceInfo(params: any) {
  return axios({
    url: "/sensor/get",
    method: "get",
    params,
  });
}
